import { JSONSchema7 } from 'json-schema';

const AllowedStacksHeaderSchema = async () => {
    let schema: JSONSchema7 = {
        title: 'AllowedStacksHeaderSchema',
        type: 'object',
        //
        definitions: {},
    };
    //
    schema = {
        properties: {
            className: {
                type: 'string',
            },
            title: {
                type: 'string',
            },
        },
        //
        ...schema,
    };
    //
    return schema;
};

export default AllowedStacksHeaderSchema;
